import { IAvailableMembership } from '@/constants';
import { apiFetch } from '@/utils';
import useSWR from 'swr';

export const useAvailableMemberships = () => {
  const { data, isLoading } = useSWR<IAvailableMembership[]>(
    `/v1/memberships`,
    async (url: string) => {
      const response = await apiFetch('/v1/memberships', {
        withCredentials: true,
      });

      return response.json();
    }
  );

  return {
    memberships: data || [],
    isLoading,
  };
};
